import { lotInspectionFromFirestore } from '@parallel-fluidics/shared/models/lots';
import {
  collection,
  getDocs,
  getFirestore,
  query,
  where,
} from 'firebase/firestore';

/**
 * Fetch every inspection record covering this lot, newest first. Sorted
 * client-side — array-contains plus orderBy would need a composite index
 * and a lot only ever has a handful of inspections.
 */
export default async function fetchLotInspections(lotId) {
  const inspectionsQuery = query(
    collection(getFirestore(), 'lotInspections'),
    where('lotIds', 'array-contains', lotId),
  );
  const snapshot = await getDocs(inspectionsQuery);
  return snapshot.docs
    .map((inspectionDoc) => lotInspectionFromFirestore(inspectionDoc))
    .sort((a, b) => {
      /* eslint-disable no-underscore-dangle */
      const millis = (record) => record._createdBy?.timestamp?.toMillis?.() ?? 0;
      /* eslint-enable no-underscore-dangle */
      return millis(b) - millis(a);
    });
}
